import { ReactElement, useMemo, memo } from 'react';
import { Stack, Typography } from '@mui/material';

import { ZoneSaturationLevelType } from '~globals/types/enums';

import { getZoneSaturationLevelConfig } from './utils';

interface DashboardVariantV2CarrierZoneSaturationTableSuggestedActionInfoCellProps {
  levelTypeId: ZoneSaturationLevelType;
  availableCapacity: number;
  overCapacity: number;
}

const DashboardVariantV2CarrierZoneSaturationTableSuggestedActionInfoCell = ({
  levelTypeId,
  availableCapacity,
  overCapacity,
}: DashboardVariantV2CarrierZoneSaturationTableSuggestedActionInfoCellProps): ReactElement => {
  const { color, actionLabel, actionDescription } = useMemo(
    () =>
      getZoneSaturationLevelConfig({
        saturationLevelTypeId: levelTypeId,
        availableCapacity,
        overCapacity,
      }),
    [availableCapacity, levelTypeId, overCapacity],
  );

  return (
    <Stack>
      <Typography variant="caption" color={color} fontWeight="bold">
        {actionLabel}
      </Typography>

      <Typography variant="caption" color="text.secondary">
        {actionDescription}
      </Typography>
    </Stack>
  );
};

export default memo(
  DashboardVariantV2CarrierZoneSaturationTableSuggestedActionInfoCell,
);
